import Vue from 'vue';
import store from '@/store';
import AccountsProxy from "../../../proxies/AccountsProxy";
import * as types from './mutation-types';

/**
 * 계정 리스트
 * @param commit
 * @param param
 */
export const findAll = ({ commit }, param) => {
  new AccountsProxy(param)
    .all()
    .then((response) => {
      commit(types.LIST, response);
    });
};

export const findById = ({ commit }, userId) => {
  new AccountsProxy()
    .find(userId)
    .then((response) => {
      // commit(types.LIST, response);
    });
};

/**
 * 게정 생성
 * @param commit
 * @param param
 */
export const createUser = ({ commit }, param) => {

  return new AccountsProxy()
    .create(param)
    
};

/**
 * 계정 수정
 * @param commit
 * @param param
 */
export const editUser = ({ commit }, param) => {
  new AccountsProxy()
    .update(param.userId, param)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        Vue.router.push({
          name: 'SettingsAccount'
        });
      } else {
        alert(response.header.resultMessages);
      }

    })
    .catch(() => {
      console.log('Request failed...');
    });
};

/**
 * 레코드 수정
 * @param {} param0 
 * @param {*} data 
 */
export const changeRecord = ( {commit}, data  ) => {

    commit(types.RECORD_CHANGE, data)

};


export const changeUserStatus = ({commit}, {userId, status}) => {

  new AccountsProxy()
  .changeUserStatus( userId, status)
  .then(res => commit(types.CHANGE_USER_STATUS, {userId, status}) )


}


export default {
  findAll,
  createUser,
  findById,
  editUser,
  changeRecord,
  changeUserStatus,
};
